import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ResponsePaginateSuccess } from '@atmi/core/models';
import { generateIndexQueryString, IndexQueryStringType } from '@atmi/core/utils';

import { Audit } from '../models/audit';
import { AuditModuleConfiguration } from '../models/configuration';
import { AuditConfigurationService } from '../token';

@Injectable({
  providedIn: 'root',
})
export class AuditsApiService {

  private readonly path = `${this.config.basePath}/operations`;

  constructor(
    @Inject(AuditConfigurationService) private readonly config: AuditModuleConfiguration,
    private readonly http: HttpClient,
  ) {
  }

  index(queryString?: IndexQueryStringType) {
    const params = generateIndexQueryString(queryString);

    return this.http.get<ResponsePaginateSuccess<Audit[]>>(this.path, { params });
  }
}
